import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, useTheme } from "@mui/material";
import { motion } from "motion/react";
import { JSX, useEffect, useState } from "react";
import { AddOutlined, RemoveOutlined } from "@mui/icons-material";

export function DevPanel(): JSX.Element | null {
  const isDevMode = import.meta.env.DEV && import.meta.env.MODE !== "test";
  if (!isDevMode) return null;

  const [hmrUpdating, setHmrUpdating] = useState(false);

  if (import.meta.hot) {
    import.meta.hot.on("vite:beforeUpdate", () => {
      setHmrUpdating(true);
    });

    import.meta.hot.on("vite:afterUpdate", () => {
      setTimeout(() => setHmrUpdating(false), 500);
    });
  }
  const { typography } = useTheme();
  const { htmlFontSize: baseHtmlFontSize, pxToRem } = typography;
  const [htmlFontSize, setHtmlFontSize] = useState<number>(baseHtmlFontSize);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeFontSize = (newSize: number) => () => {
    document.documentElement.style.setProperty("font-size", `${newSize}px`);
    setHtmlFontSize(newSize);
  };

  const [isServerSide, setIsServerSide] = useState(true);
  useEffect(() => setIsServerSide(false), []);
  if (isServerSide) return null;

  return (
    <>
      <Box
        sx={{
          display: "block",
          position: "fixed",
          bottom: "50vh",
          left: pxToRem(1),
          zIndex: 10,
          cursor: "default",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            ["img"]: {
              width: pxToRem(24),
              paddingLeft: "0",
            },
          }}
        >
          <IconButton sx={{ px: 0.5 }} onClick={handleClick}>
            <motion.img
              height={16}
              width={16}
              src="https://vite.dev/logo.svg"
              title="Vite Dev Server is Running"
              animate={hmrUpdating ? { scale: [1, 1.5, 1] } : { scale: 1 }}
              transition={{ repeat: hmrUpdating ? Infinity : 0, duration: 1 }}
              style={{
                display: "inline-block",
                width: pxToRem(16),
                height: pxToRem(16),
              }}
            />
          </IconButton>
        </Box>
      </Box>
      <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Box sx={{ textAlign: "center", p: 1 }}>
          <strong>HTML font-size</strong>
          <div>Base: {baseHtmlFontSize}px</div>

          <div>
            Current: {htmlFontSize}px ({Math.round((htmlFontSize / baseHtmlFontSize) * 100)}
            %)
          </div>
        </Box>
        <MenuItem onClick={changeFontSize(htmlFontSize + 1)}>
          <ListItemIcon>
            <AddOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Increase html font-size {htmlFontSize + 1}</ListItemText>
        </MenuItem>
        <MenuItem onClick={changeFontSize(htmlFontSize - 1)}>
          <ListItemIcon>
            <RemoveOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Decrease html font-size {htmlFontSize - 1}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
